import { render, staticRenderFns } from "./Corrigir.vue?vue&type=template&id=95e9459a"
import script from "./Corrigir.vue?vue&type=script&lang=js"
export * from "./Corrigir.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports